import * as types from "../constants/actionConstants";
import * as TEMPLATE from "../constants/templateConstants";
import {initGetTemplateList} from "./templateListActions";
import {getOutstandingQuestionnaireTemplateCount} from "./questionnaireTemplateActions";
import TemplateAPI from "../api/TemplateApi";
import * as portalTypes from "../portal/constants/actionConstants";

export function openDrawer(props, view, template) {
    return (dispatch) => {
        dispatch({type: types.OPEN_DRAWER,
            template,
            view,
            props});
        setTimeout(() => {
            dispatch({type: portalTypes.INCREMENT_PORTAL_COUNT});
        }, 500);
    };
}

export function closeDrawer() {
    return (dispatch) => {
        dispatch({type: types.CLOSE_DRAWER});
        dispatch({type: types.REVIEW_TEMPLATE_CALLBACK_CLEAR});
    }
}

// -----------------------------------------------------------------------------------------------------------------
// Publish !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! <editor-fold>
// -----------------------------------------------------------------------------------------------------------------

export function publish(id, publishDTO, key, filter, versionsFilter) {

    return (dispatch) => {
        TemplateAPI.publishQuestionnaire(id, publishDTO)
            .then((response) => {
                return dispatch(publishSuccess(key, response, filter, versionsFilter));
            })
            .catch((error) => {
                dispatch(publishFailure());
                console.log(error.message);// eslint-disable-line
            });
    };

}

// Publish actions
export function publishSuccess(key, response, filter, versionsFilter) {
    return (dispatch) => {

        if (key !== undefined) {
            dispatch(initGetTemplateList(versionsFilter, TEMPLATE.TYPE.QUESTIONNAIRE, TEMPLATE.MODE.VERSIONS, key));
        }
        dispatch(getOutstandingQuestionnaireTemplateCount());
        dispatch(initGetTemplateList(filter, TEMPLATE.TYPE.QUESTIONNAIRE, TEMPLATE.MODE.CURRENT));
        dispatch(closeDrawer());
    };
}

export function publishFailure() {
    return {
        type: types.PUBLISH_FAIL
    };
}



//</editor-fold>
// -----------------------------------------------------------------------------------------------------------------

// -----------------------------------------------------------------------------------------------------------------
// Change Date !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! <editor-fold>
// -----------------------------------------------------------------------------------------------------------------

export function changeDate(id, changeDateDTO, key, filter, versionsFilter) {

    return (dispatch) => {
        TemplateAPI.changeQuestionnaireDates(id, changeDateDTO)
            .then((response) => {
                return dispatch(changeDateSuccess(key, response, filter, versionsFilter));

            })
            .catch((error) => {
                dispatch(changeDateFailure());
                console.log(error.message);// eslint-disable-line

            });
    };

}

// Change Dates actions
export function changeDateSuccess(key, response, filter, versionsFilter) {
    return (dispatch) => {
        if (key !== undefined) {
            dispatch(initGetTemplateList(versionsFilter, TEMPLATE.TYPE.QUESTIONNAIRE, TEMPLATE.MODE.VERSIONS, key));
        }
        dispatch(initGetTemplateList(filter, TEMPLATE.TYPE.QUESTIONNAIRE, TEMPLATE.MODE.CURRENT));
        dispatch(closeDrawer());
    };
}

export function changeDateFailure() {
    return {
        type: types.CHANGE_DATE_FAIL,
    };
}

//</editor-fold>
// -----------------------------------------------------------------------------------------------------------------


// -----------------------------------------------------------------------------------------------------------------
// Scoring !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! <editor-fold>
// -----------------------------------------------------------------------------------------------------------------

// export function scoringUpdate(scoringUpdateObj, filter) {
//
//     return (dispatch) => {
//         TemplateAPI.updateScoring(scoringUpdateObj)
//             .then(() => {
//                 dispatch(initGetTemplateList(filter, TEMPLATE.TYPE.QUESTIONNAIRE, TEMPLATE.MODE.CURRENT));
//                 return dispatch({type: types.SCORING_UPDATE_SUCCESS});
//             })
//             .catch((error) => {
//                 dispatch({type: types.SCORING_UPDATE_FAIL});
//                 console.log(error.message);// eslint-disable-line
//
//             });
//     };
//
// }

